import script from "./LoginForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginForm.vue?vue&type=script&setup=true&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=70e57c63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70e57c63"]])

export default __exports__